<template>
  <div v-cloak>
    <div class="vx-card mb-4">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body gap-y-6">
          <div class="vx-row mb-2 gap-y-6">
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full my-1">
              <label class="vs-select--label datepicker-lb">{{
                $t("FromDate")
              }}</label>
              <div class="relative">
                <date-picker
                  v-model="gridSearchData.FromDate"
                  type="datetime"
                  format="jYYYY-jMM-jDD HH:mm:ss"
                  display-format="jYYYY-jMM-jDD HH:mm:ss"
                  class="date-picker relative"
                  :label="$t('FromDate')"
                  :clearable="true"
                  name="fromDate"
                  :class="[errors.has('fromDate') ? 'error-input-orders' : '']"
                  v-validate="{ required: true }"
                />
                <span
                  v-show="errors.has('fromDate')"
                  style="bottom: -20px"
                  class="absolute text-danger text-sm"
                  >{{ errors.first("fromDate") }}</span
                >
              </div>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full my-1">
              <label class="vs-select--label datepicker-lb">{{
                $t("ToDate")
              }}</label>
              <div class="relative">
                <date-picker
                  v-model="gridSearchData.ToDate"
                  type="datetime"
                  format="jYYYY-jMM-jDD HH:mm:ss"
                  display-format="jYYYY-jMM-jDD HH:mm:ss"
                  class="date-picker"
                  :label="$t('ToDate')"
                  :clearable="true"
                  name="toDate"
                  :class="[errors.has('toDate') ? 'error-input-orders' : '']"
                  v-validate="{ required: true }"
                />
                <span
                  v-show="errors.has('toDate')"
                  style="bottom: -20px"
                  class="absolute text-danger text-sm"
                  >{{ errors.first("toDate") }}</span
                >
              </div>
            </div>
            <div class="vx-col my-1">
              <div class="flex justify-end gap-6 items-end h-full">
                <vs-button
                  @click.prevent="downloadFile()"
                  class="bg_purple"
                  style="height: 39px !important"
                  :disabled="loading"
                >
                  <div class="flex gap-2 items-center">
                    <span>{{ $t("DownloadExcelFile") }}</span>
                    <img
                      v-if="loading"
                      src="@/assets/images/loading.gif"
                      class="w-6 h-6"
                    />
                  </div>
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { mapActions } from "vuex";
import utils from "@/assets/utils/index";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    fromDate: {
      required: "لطفا تاریخ را وارد نمایید.",
    },
    toDate: {
      required: "لطفا تاریخ را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "",
  data() {
    return {
      showFilters: false,
      gridSearchData: {},
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      exportSamanehJameCustomersQuery: "excel/exportSamanehJameCustomersQuery",
    }),
    downloadFile() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          var params = utils.toQueryString(this.gridSearchData);
          this.exportSamanehJameCustomersQuery(params)
            .then(() => {
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
};
</script>

<style>
body[dir="rtl"] .error-input-orders input {
  border-color: rgb(197, 55, 55) !important;
}
</style>
